const SOLUQR_DOMAINS = ['localhost', 'soluqr.cl'];

export function isCustomDomain(hostname = '') {
  hostname = hostname.toLowerCase();

  return !SOLUQR_DOMAINS.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
}
